import React from 'react';
import { Button } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faFilter, faEdit, faPlus, faPrint } from '@fortawesome/free-solid-svg-icons';
import "../../assets/css/cardCadastros.css";
import TextField from '../../components/TextField/TextField';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
export default function MainCard({ search = null,
    btnVoltarInTop,
    noCard = false,
    title,
    btnCadastro,
    btnClick,
    icon = null,
    onClick,
    onClickBtnCadastro,
    link,
    children,
    btnVoltar,
    btnFiltros,
    btnEditar,
    btnExcluir,
    btnEditarInTop,
    btnExcluirInTop,
    btnImprimir,
    btnActionTitle,
    BtnAction1 = null,
    BtnAction2 = null,
    BtnAction1InTop = null,
    visivel = true }) {
    const navigate = useNavigate();
    return (
        <div className='d-flex justify-content-center mt-4'>
            <div className={`CardCadastros${noCard ? "-noCard" : " shadow"} `}>
                {btnVoltarInTop || btnImprimir || btnEditarInTop || btnExcluirInTop || BtnAction1InTop ?


                    <div className="d-flex align-items-center justify-content-between">

                        <div>
                            {
                                btnVoltarInTop &&
                                <Button className='d-inline   rounded-3 mb-3' onClick={btnVoltarInTop}>
                                    <FontAwesomeIcon icon={faArrowLeft} className={"me-2"} />
                                    Voltar
                                </Button>
                            }


                        </div>
                        <div>


                            {BtnAction1InTop && <BtnAction1InTop />}
                            {btnImprimir &&
                                <Button className='me-4 ms-4 d-inline  rounded-3 mb-3' color='secondary text-light' onClick={btnImprimir}>
                                    <FontAwesomeIcon icon={faPrint} className={"me-2"} />
                                    Imprimir
                                </Button>
                            }
                            {
                                btnEditarInTop &&
                                <Button className='mb-3 d-inline  rounded-3 ' color='warning' style={{ color: "#fff" }} onClick={btnEditarInTop}>
                                    <FontAwesomeIcon icon={faEdit} className={"me-2"} />
                                    Editar
                                </Button>
                            }
                            {
                                btnExcluirInTop &&
                                <Button className='mb-3 d-inline  rounded-3 ' color='danger' style={{ color: "#fff" }} onClick={btnExcluirInTop}>
                                    <FontAwesomeIcon icon={faEdit} className={"me-2"} />
                                    Excluir
                                </Button>
                            }
                        </div>
                    </div>
                    : <></>}
                {title || btnVoltar || btnCadastro || btnActionTitle || btnFiltros || btnClick || btnEditar || btnExcluir || BtnAction1 || BtnAction2 ?
                    <div className='d-flex  flex-row justify-content-between align-items-center w-100 mb-3'>

                        <div className='w-100 d-flex align-items-center justify-content-between flex-wrap'>
                            {(btnVoltar || title) && <div className='d-flex'>
                                {
                                    btnVoltar &&
                                    <Button className='d-inline   rounded-3 ' onClick={btnVoltar}>
                                        <FontAwesomeIcon icon={faArrowLeft} className={"me-2"} />
                                        Voltar
                                    </Button>
                                }
                                <h4 className='ms-2'>{title} </h4>
                            </div>}
                            {search && search.type == "select" &&
                                <div className='w-50 d-flex align-items-center '>
                                    <TextField label={search.label ? search.label : null} placeholder={search.placeholder} className={`${search.className}`} name={search.name} value={search.value} options={search.options ? search.options : []} onChange={search.onChange} onBlur={search.onBlur} type={search.type} inputClassName={search.inputClassName} customStyles={search.customStyles} multiple={search.multiple ? true : false} />
                                    <Button className=' ms-3' color='primary' onClick={search.onClick}><FontAwesomeIcon icon={faSearch} /></Button>
                                </div>
                            }
                            {search && search.type != "select" &&
                                <TextField className={search.className} name={search.name} value={search.value} onClickIcon={search.onClick} onChange={search.onChange} onBlur={search.onBlur} type={search.type} inputClassName={search.inputClassName} customStyles={search.customStyles} multiple={search.multiple ? true : false} icon={faSearch} />
                            }
                            {btnActionTitle &&
                                <Button name={btnActionTitle.name ? btnActionTitle.name : 'btnActionTitle'} className='d-inline  rounded-3 mb-3' color={btnActionTitle.bootstrapColor ? btnActionTitle.bootstrapColor : null} style={btnActionTitle.style ? btnActionTitle.style : null} onClick={btnActionTitle.onClick}>
                                    {btnActionTitle.icon ? <FontAwesomeIcon icon={btnActionTitle.icon} className={"me-2"} /> : ""}
                                    {btnActionTitle.label ? btnActionTitle.label : null}
                                </Button>
                            }
                            {btnFiltros &&
                                <>
                                    {!btnCadastro && <span></span>}
                                    <div>
                                        <Button className='fw-bold text-center ms-2' color='primary' onClick={btnFiltros}><FontAwesomeIcon className='me-2' icon={faFilter} size={"1x"} /> {`filtros`}</Button>
                                    </div>
                                </>
                            }
                            {btnCadastro && visivel &&
                                <>
                                    <span></span>
                                    <div>
                                        <Button className='fw-bold text-center ms-2' color='success' onClick={onClickBtnCadastro ? onClickBtnCadastro : () => navigate(link)}><FontAwesomeIcon className='me-2' icon={faPlus} size={"1x"} /> {`${btnCadastro}`}</Button>
                                    </div>
                                </>
                            }
                            {(BtnAction1 || BtnAction2) &&
                                <div>
                                    {BtnAction1 && <BtnAction1 />}
                                    {BtnAction2 && <BtnAction2 />}
                                </div>
                            }
                            {
                                btnEditar &&
                                <Button className='ms-3 d-inline  rounded-3 ' color='warning' style={{ color: "#fff" }} onClick={btnEditar}>
                                    <FontAwesomeIcon icon={faEdit} className={"me-2"} />
                                    Editar
                                </Button>
                            }
                            {
                                btnExcluir &&
                                <Button className='ms-3 d-inline  rounded-3 ' color='danger' style={{ color: "#fff" }} onClick={btnExcluir}>
                                    <FontAwesomeIcon icon={faEdit} className={"me-2"} />
                                    Excluir
                                </Button>
                            }
                            {btnClick &&
                                <div>
                                    <Button className='fw-bold text-center ms-2' color='success' onClick={onClick}><FontAwesomeIcon className='me-2' icon={icon} size={"1x"} /> {`${btnClick}`}</Button>
                                </div>
                            }
                        </div>

                    </div>
                    : <></>
                }
                {children}
            </div>
        </div>
    )
}